module.exports = __webpack_public_path__ + "img/big_1_27.17cdb792.png";